import React , { useEffect, useState } from 'react';
import type { JSX } from 'react';
import {
  UserGroupIcon,
  ClockIcon,
  MapPinIcon,
  DocumentTextIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/outline';
import { api } from '../../services/api';
import StatCard from '../StatCard';
import { MasonryGrid, MasonryItem } from '../layout/Masonry'; 

type Props = {
  date: string; // Format YYYY-MM-DD
};

type InfoType = {
  typefiche: string;
  total: number;
};

// Mapping typefiche -> titre + icône
const ficheMap: Record<
  string,
  { label: string; icon: JSX.Element }
> = {
  CONTRAT: {
    label: 'Contrats',
    icon: <DocumentTextIcon className="h-7 w-7" />,
  },
  PASSAGE: {
    label: 'Passages',
    icon: <MapPinIcon className="h-7 w-7" />,
  },
  LISTATT: {
    label: 'Liste d’attente',
    icon: <ClockIcon className="h-7 w-7" />,
  },
  ZONETECH: {
    label: 'Zone technique',
    icon: <WrenchScrewdriverIcon className="h-7 w-7" />,
  },
};

export default function InfoGlobalCards({ date }: Props) {
  const [data, setData] = useState<InfoType[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        setError('');
        const res = await api.get('/info-global', { params: { date } });
        setData(res.data.types || []);
      } catch (err: any) {
        console.error("Erreur API", err);
        setError(err?.response?.data?.error || 'Erreur de chargement');
      }
    };

    fetchInfo();
  }, [date]);

  if (error) return <div className="text-red-600">{error}</div>;

 
  
    return (
      <>
        {data.map((item, idx) => {
          const fallback = {
            label: item.typefiche.charAt(0) + item.typefiche.slice(1).toLowerCase(),
            icon: <UserGroupIcon className="h-7 w-7" />,
          };
          const { label, icon } = ficheMap[item.typefiche] || fallback;
          return (
            <MasonryItem key={idx} className="break-inside-avoid">
              <StatCard
                icon={icon}
                title={`${label}`}
                value={item.total.toString()}
              />
            </MasonryItem>
          );
        })}
      </>
    );
  


} 
